var _defs, _rect, _ellipse, _ellipse2, _ellipse3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPumpkin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 6,
    floodOpacity: 0.25
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 66,
    width: 20,
    height: 28,
    rx: 6,
    fill: "#2e7d32"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128,
    cy: 140,
    rx: 90,
    ry: 70,
    fill: "#f59e0b",
    filter: "url(#shadow)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102,
    cy: 140,
    rx: 60,
    ry: 68,
    fill: "#fb923c",
    opacity: 0.95
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 154,
    cy: 140,
    rx: 60,
    ry: 68,
    fill: "#fb923c",
    opacity: 0.95
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 66c-8 8-10 16-6 24",
    stroke: "#2e7d32",
    strokeWidth: 4,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpkin);
export default __webpack_public_path__ + "static/media/pumpkin.b746016071e4765fbc452443d8452e01.svg";
export { ForwardRef as ReactComponent };